import {  useState } from 'react'
import { ProfileTemplate } from '@/widgets'

import { userSelectors } from '@/entity'
import { RedirectUnAuthUser } from '@/processes'
import { useDispatch, useSelector } from 'react-redux'

import * as React from 'react'
import { styled } from '@mui/system'
import TabsUnstyled from '@mui/base/Tabs'
import TabPanelUnstyled from '@mui/base/TabPanel'
import { useTranslation } from 'react-i18next'
import { EmploymentContracts } from '@features/contracts/employmentContracts'
import { TransferRequests } from '@features/contracts/transferRequests'
import { ElectronicContractsRequests } from '@features/contracts/electronicContractsRequests'
import Tab from '@/ui/atoms/tab'
import TabsList from '@/ui/atoms/tabsList'
import { employerProfileSelectors } from '@features/employerProfile/model'
import { CorrectionRequests } from '@features/contracts/correctionRequests'
import { CollectiveContracts } from '@/features'

const TabPanel = styled(TabPanelUnstyled)({
	width: '100%',
	maxWidth: '90vw',
	margin: '32px 34px 0 0',
	fontFamily: 'Inter, sans-serif',
	fontSize: '0.875rem',
})

const Tabs = styled(TabsUnstyled)({})

export const EmploymentContractsPage = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const activeCompany = useSelector(employerProfileSelectors.activeCompany)
	const [activeTab, setActiveTab] = useState(0)
	const isMobile = window.innerWidth < 768
	const activeRole = useSelector(userSelectors.activeRole)

	const handleChangeTab = (tab) => setActiveTab(tab)

	return (
		<>
			{/*раскомментировать в случае траура*/}
			{/*<PreHeader />*/}
			<RedirectUnAuthUser>
				<ProfileTemplate title={'employment_contract'}>
					{/* Вкладки договоров */}
					<Tabs defaultValue={0} value={activeTab} onChange={(_, value) => handleChangeTab(value)}>
						<TabsList>
							<Tab value={0}>{t('employment_contracts')}</Tab>
							{activeRole !== 'ROLE_EMPLOYEE' && (
								<div className={'flex'}>
									{!activeCompany.flEmployer ? (
										<>
											<Tab value={1}>{t('worker_transfer_requests')}</Tab>
											<Tab value={2}>{t('correction_requests_tab')}</Tab>
										</>
									) : null}
								</div>
							)}
							<Tab value={3}>{t('term_etd_requests')}</Tab>
							{activeRole !== 'ROLE_EMPLOYEE' && activeCompany?.collectiveContract ? (
								<Tab value={4}>{t('collective_contract')}</Tab>
							) : null}
						</TabsList>
						{/* Обычный трудовой договор */}
						<TabPanel value={0}>
							<EmploymentContracts setActiveTab={handleChangeTab} />
						</TabPanel>
						{activeRole !== 'ROLE_EMPLOYEE' ? (
							<TabPanel value={1}>
								<TransferRequests />
							</TabPanel>
						) : null}
						{/* Запросы на изменения ЭТК */}
						{activeRole !== 'ROLE_EMPLOYEE' ? (
							<TabPanel value={2}>
								<CorrectionRequests />
							</TabPanel>
						) : null}
						<TabPanel value={3}>
							<ElectronicContractsRequests setActiveTab={handleChangeTab} />
						</TabPanel>
						{activeRole !== 'ROLE_EMPLOYEE' && activeCompany?.collectiveContract ? (
							<TabPanel value={4}>
								<CollectiveContracts activeTab={activeTab} isMobile={isMobile}></CollectiveContracts>
							</TabPanel>
						) : null}
					</Tabs>
				</ProfileTemplate>
			</RedirectUnAuthUser>
		</>
	)
}
